import './index.less'
import '../../snippets/what-is-in-the-box/index.less'
import { gaProductDetailDataLayer, replaceLineBreak } from '@utils/index.js'

// 规格
if (!customElements.get('product-specs')) {
  customElements.define('product-specs', class ProductSpecs extends HTMLElement {
    constructor() {
      super()
      this.selectors = {
        accordion_header: $(this).find(".accordion-ul .accordion-header"),
        specs_dom: $(this).find(".accordion-content--with-child.specs"),
        manual: $(this).find(".manual-list")
      }

      // 规格 section title
      this.productSpecsTitle = this.querySelector('.tech--title').innerText

      this.init()
      this?.getSpecsInfo()
      this?.getUserManual()
    }

    init() {
      this.specVariant()
      this.selectors.accordion_header.click(function () {
        $(this).next('.accordion-content').slideToggle()
        $(this).find(".accordion-close").toggleClass("active")
      })

      // 监听变体切换
      document.addEventListener('variantChangeEvent', e => {
        const currentVariant = e.detail.variant
        if (currentVariant) {
          this?.getSpecsInfo(currentVariant.id)
          this?.getUserManual(currentVariant.id)
        }
      })
    }

    specVariant(init = true) { // 加电包
      $(".accordion-header--variant:not(.active)").next('.accordion-content').slideUp(0)
      $(".accordion-header--variant:not(.active)").find(".accordion-close").removeClass("active")

      if (!init) {
        $(".accordion-header--variant.active").next('.accordion-content').slideDown(0)
        $(".accordion-header--variant.active").find(".accordion-close").addClass("active")
      }
    }

    createSpecsItemDom(obj) {
      let html = ''
      for (let n in obj) {
        if (typeof (obj[n]) === 'string') {
          html += `
              <div class="specs-item">
                <span class="key">${n}</span>
                <span class="value">${replaceLineBreak(obj[n])}</span>
              </div>
            `
        } else {
          html += this.createSpecsItemDom(obj[n])
        }
      }
      return html
    }

    createSpecsDom(data = []) {
      let box = '';
      data.map(item => {
        if (item.baseInfos) {
          // 过滤特殊逻辑
          Object.keys(item.baseInfos).forEach(key => {
            if (['Price', 'In The Box', 'Solar Charging Time'].includes(key)) {
              delete item.baseInfos[key]
            }
          })

          let row = '';
          for (let i in item.baseInfos) {
            let col = '';
            if (item.baseInfos[i]) {
              let obj = item.baseInfos[i]
              if (typeof (obj) === 'string') {
                col += `
                  <div class="specs-item">
                    <span class="key">${obj}</span>
                  </div>
                `
              } else {
                col += this.createSpecsItemDom(obj)
              }
            }
            row += `
              <div class="specs-row w-full">
                <div class="title">${i}</div>
                <div class="specs-wrap">
                  ${col}
                </div>
              </div>
            `
          }
          box += `
            <div class="accordion-ul">
              <div class="accordion-header">
                <h3 class="jky-text-lg font-bold">${item.title}</h3>
                <svg class="accordion-close active" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2530" width="36" height="36"><path d="M512 671.288889L785.066667 398.222222l-56.888889-62.577778L512 551.822222 295.822222 335.644444 233.244444 398.222222z" fill="currentColor" opacity=".6" p-id="2531"></path></svg>
              </div>

              <div class="accordion-content">
                <div class="item-box-content w-full">${row}</div>
              </div>
            </div>
          `
        }
      })
      return box
    }

    // 产品参数获取
    getSpecsInfo(skuId) {
      const _this = this
      var sku_id = skuId
      if (!skuId) {
        const productForm = document.querySelector("product-form")
        const variantFields = document.querySelector('variant-fields')
        sku_id = productForm?.querySelector('[name=id]')?.value
          || variantFields?.currentVariant?.id
          || this.getAttribute("data-id")
      }

      fetch(`${pageInfo.api}/osconsumerapi/app-product-comparison/consumer/detail?shopifyShopId=${pageInfo.shopId}&skuId=${sku_id}`)
        .then((response) => response.json())
        .then(res => {
          let data = res.data;
          let dom = this.createSpecsDom(data)
          if (data && Array.isArray(data) && data.length) {
            document.querySelector(".accordion--product-specs") && document.querySelector(".accordion--product-specs").classList.remove("hidden")
            this.selectors.specs_dom.html(dom)
            this.selectors.specs_dom.find(".accordion-header").click(function () {
              $(this).next('.accordion-content').slideToggle()
              $(this).find(".accordion-close").toggleClass("active")

              // 只记录二级产品参数的埋码
              gaProductDetailDataLayer({
                "product_spu_name": _this.dataset.productTitle, // 识别页面产品spu标题名称text
                "module": "Parameter", // 固定名称Parameter
                "content": _this.productSpecsTitle, // 识别参数配置标题文本text
                "position": _this.selectors.specs_dom?.prev()?.text()?.trim(), // 一级展开分类文本text
                "button_name": $(this)?.text()?.trim(), // 二级展开分类文本text,或者产品说明书名称
                "type": $(this).find(".accordion-close").hasClass("active") ? "open" : "fold", // 折叠fold，展开open / 下载-PDF Download
              })
            })
          } else {
            this.selectors.specs_dom.find('.accordion-ul').empty()
            document.querySelector(".accordion--product-specs") && document.querySelector(".accordion--product-specs").classList.add("hidden")
          }
        })
        .catch(e => console.error("Fetch error: getSpecsInfo", e))
    }

    // 说明书
    getUserManual(sku) {
      const productForm = document.querySelector("product-form")
      const variantFields = document.querySelector('variant-fields')

      var sku_id = sku
      if (!sku) {
        sku_id = productForm?.querySelector('[name=id]')?.getAttribute("data-sku")
          || variantFields?.currentVariant?.sku
          || this.getAttribute("data-sku")
      }
      this.selectors.manual.find("dd").remove();

      // 如果shopify元字段有配置，则取shopify的，没有则取接口
      const current_id = productForm?.querySelector('[name=id]')?.value
        || variantFields?.currentVariant?.id
        || this.getAttribute("data-id")
      const _currentVariant = window.product.productVariants[current_id]
      const batteryInfos = _currentVariant.batteryInfos || []
      if (batteryInfos.length > 0) {
        document.querySelector(".accordion--manual") && document.querySelector(".accordion--manual").classList.remove("hidden")
        let dd = '';
        batteryInfos.forEach(item => {
          dd += `
              <dd>
                <p class="jky-text-sm font-500">
                  <svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                      <g transform="translate(-155.000000, -4087.000000)" stroke="#333333" stroke-width="2">
                        <g transform="translate(120.000000, 3988.000000)">
                          <g transform="translate(24.000000, 88.000000)">
                            <g transform="translate(12.000000, 12.000000)">
                              <path d="M35.1219512,33.1707317 L35.1219512,37.671137 C35.1219512,38.9572127 34.1185581,40 32.8810674,40 L6.63112772,40 C5.39363706,40 4.3902439,38.9572127 4.3902439,37.671137 L4.3902439,33.2640066" id="Stroke-1"></path>
                              <path d="M4.3902439,16.51676 L4.3902439,2.28040889 C4.3902439,1.02109117 5.39363706,0 6.63112772,0 L32.8810674,0 C34.1185581,0 35.1219512,1.02109117 35.1219512,2.28040889 L35.1219512,16.5853659" id="Stroke-3"></path>
                              <path d="M38.3476085,33.1707317 L1.65239148,33.1707317 C0.739610262,33.1707317 0,32.4236961 0,31.5017509 L0,18.2543467 C0,17.3324015 0.739610262,16.5853659 1.65239148,16.5853659 L38.3476085,16.5853659 C39.2603897,16.5853659 40,17.3324015 40,18.2543467 L40,31.5017509 C40,32.4236961 39.2603897,33.1707317 38.3476085,33.1707317 Z" id="Stroke-5"></path>
                              <line x1="10.2439024" y1="5.6097561" x2="29.2682927" y2="5.6097561" id="Stroke-7"></line>
                              <line x1="10.2439024" y1="10.9756098" x2="29.2682927" y2="10.9756098" id="Stroke-9"></line>
                              <line x1="10.4878049" y1="29.2682927" x2="10.4878049" y2="21.4634146" id="Stroke-11"></line>
                              <polyline id="Stroke-13" points="24.8780488 29.2682927 24.8780488 21.4634146 28.7804878 21.4634146"></polyline>
                              <path d="M10.7317073,21.4634146 L13.385397,21.4634146 C14.3441607,21.4634146 15.1219512,22.2282453 15.1219512,23.1709435 C15.1219512,24.1140652 14.3441607,24.8780488 13.385397,24.8780488 L10.7317073,24.8780488" id="Stroke-15"></path>
                              <path d="M18.612952,29.2682927 L17.0731707,29.2682927 L17.0731707,21.4634146 L18.612952,21.4634146 C20.7263935,21.4634146 22.4390244,23.2106546 22.4390244,25.3658537 C22.4390244,27.5210527 20.7263935,29.2682927 18.612952,29.2682927 Z" id="Stroke-17"></path>
                              <line x1="28.7804878" y1="25.1219512" x2="24.8780488" y2="25.1219512" id="Stroke-19"></line>
                            </g>
                          </g>
                        </g>
                      </g>
                    </g>
                  </svg>
                  <span>${item.title}</span>
                </p>
                <span data-href="${item.url}" data-title="${item.title}" class="z-button-fill-middle font-500">
                <jds-icon name="download"></jds-icon>&nbsp;<span>${window.pageInfo.strings.product.download}</span></span>
              </dd>
            `;
        })
        this.selectors.manual.prepend(dd)

        // 给 download 按钮，注册埋码事件
        const _this = this
        this.selectors.manual.find('.z-button-fill-middle').click(function () {
          // 数据埋码
          gaProductDetailDataLayer({
            "product_spu_name": _this.dataset.productTitle, // 识别页面产品spu标题名称text
            "module": "Parameter", // 固定名称Parameter
            "content": _this.productSpecsTitle, // 识别参数配置标题文本text
            "position": _this.selectors.manual.data("section-title"), // 一级展开分类文本text
            "button_name": $(this)?.data("title"), // 产品说明书名称
            "type": "PDF Download", // 折叠fold，展开open / 下载-PDF Download
          })

          window.open($(this).data('href'), '_blank')
        })
        return false
      } else {
        if (document.querySelector(".accordion--manual")) {
          document.querySelector(".accordion--manual").classList.add("hidden")
          const previousElementSibling = document.querySelector(".accordion--manual").previousElementSibling
          if (previousElementSibling) {
            previousElementSibling.classList.add("!mb-0")
          }
        }
      }

      // 判断是套装还是单品, 套装查询getPackagedInfo, 单品查询getGoodsInfo
      if (this.selectors.manual.attr("type") === 'sg_gather') {
        fetch(`${pageInfo.api}/osconsumerapi/v1/goods/packaged-info?shopify_shop_id=${pageInfo.shopId}&sku=${sku_id}`)
          .then((response) => response.json())
          .then(res => {
            let dd = '';
            res.data.filter((item) => !!item.introduceBookUrlDesc).forEach((item) => {
              dd += `
                  <dd>
                    <p class="jky-text-sm font-500">
                      <svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                          <g transform="translate(-155.000000, -4087.000000)" stroke="#333333" stroke-width="2">
                            <g transform="translate(120.000000, 3988.000000)">
                              <g transform="translate(24.000000, 88.000000)">
                                <g transform="translate(12.000000, 12.000000)">
                                  <path d="M35.1219512,33.1707317 L35.1219512,37.671137 C35.1219512,38.9572127 34.1185581,40 32.8810674,40 L6.63112772,40 C5.39363706,40 4.3902439,38.9572127 4.3902439,37.671137 L4.3902439,33.2640066" id="Stroke-1"></path>
                                  <path d="M4.3902439,16.51676 L4.3902439,2.28040889 C4.3902439,1.02109117 5.39363706,0 6.63112772,0 L32.8810674,0 C34.1185581,0 35.1219512,1.02109117 35.1219512,2.28040889 L35.1219512,16.5853659" id="Stroke-3"></path>
                                  <path d="M38.3476085,33.1707317 L1.65239148,33.1707317 C0.739610262,33.1707317 0,32.4236961 0,31.5017509 L0,18.2543467 C0,17.3324015 0.739610262,16.5853659 1.65239148,16.5853659 L38.3476085,16.5853659 C39.2603897,16.5853659 40,17.3324015 40,18.2543467 L40,31.5017509 C40,32.4236961 39.2603897,33.1707317 38.3476085,33.1707317 Z" id="Stroke-5"></path>
                                  <line x1="10.2439024" y1="5.6097561" x2="29.2682927" y2="5.6097561" id="Stroke-7"></line>
                                  <line x1="10.2439024" y1="10.9756098" x2="29.2682927" y2="10.9756098" id="Stroke-9"></line>
                                  <line x1="10.4878049" y1="29.2682927" x2="10.4878049" y2="21.4634146" id="Stroke-11"></line>
                                  <polyline id="Stroke-13" points="24.8780488 29.2682927 24.8780488 21.4634146 28.7804878 21.4634146"></polyline>
                                  <path d="M10.7317073,21.4634146 L13.385397,21.4634146 C14.3441607,21.4634146 15.1219512,22.2282453 15.1219512,23.1709435 C15.1219512,24.1140652 14.3441607,24.8780488 13.385397,24.8780488 L10.7317073,24.8780488" id="Stroke-15"></path>
                                  <path d="M18.612952,29.2682927 L17.0731707,29.2682927 L17.0731707,21.4634146 L18.612952,21.4634146 C20.7263935,21.4634146 22.4390244,23.2106546 22.4390244,25.3658537 C22.4390244,27.5210527 20.7263935,29.2682927 18.612952,29.2682927 Z" id="Stroke-17"></path>
                                  <line x1="28.7804878" y1="25.1219512" x2="24.8780488" y2="25.1219512" id="Stroke-19"></line>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <span>${item.title}</span>
                    </p>
                    <span data-href="${item.introduceBookUrlDesc}" data-title="${item.title}" class="z-button-fill-middle font-500">
                    <jds-icon name="download"></jds-icon>&nbsp;<span>${window.pageInfo.strings.product.download}</span></span>
                  </dd>
                `;
            });

            this.selectors.manual.prepend(dd)

            if (document.querySelector(".accordion--manual") && document.querySelectorAll(".accordion--manual dl dd").length > 0) {
              document.querySelector(".accordion--manual").classList.remove("hidden")
              const previousElementSibling = document.querySelector(".accordion--manual").previousElementSibling
              if (previousElementSibling) {
                previousElementSibling.classList.remove("!mb-0")
              }
            }

            // 给 download 按钮，注册埋码事件
            const _this = this
            this.selectors.manual.find('.z-button-fill-middle').click(function () {
              gaProductDetailDataLayer({
                "product_spu_name": _this.dataset.productTitle, // 识别页面产品spu标题名称text
                "module": "Parameter", // 固定名称Parameter
                "content": _this.productSpecsTitle, // 识别参数配置标题文本text
                "position": _this.selectors.manual.data("section-title"), // 一级展开分类文本text
                "button_name": $(this)?.data("title"), // 产品说明书名称
                "type": "PDF Download", // 折叠fold，展开open / 下载-PDF Download
              })

              window.open($(this).data('href'), '_blank')
            })
          })
      } else {
        fetch(`${pageInfo.api}/osconsumerapi/v1/goods/info?shopify_shop_id=${pageInfo.shopId}&sku=${sku_id}`)
          .then((response) => response.json())
          .then(r => {
            if (r.data && r.data.introduceBookUrlDesc) {
              const d_html = `
                  <dd>
                    <p class="jky-text-sm font-500">
                      <svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round">
                          <g transform="translate(-155.000000, -4087.000000)" stroke="#333333" stroke-width="2">
                            <g transform="translate(120.000000, 3988.000000)">
                              <g transform="translate(24.000000, 88.000000)">
                                <g transform="translate(12.000000, 12.000000)">
                                  <path d="M35.1219512,33.1707317 L35.1219512,37.671137 C35.1219512,38.9572127 34.1185581,40 32.8810674,40 L6.63112772,40 C5.39363706,40 4.3902439,38.9572127 4.3902439,37.671137 L4.3902439,33.2640066" id="Stroke-1"></path>
                                  <path d="M4.3902439,16.51676 L4.3902439,2.28040889 C4.3902439,1.02109117 5.39363706,0 6.63112772,0 L32.8810674,0 C34.1185581,0 35.1219512,1.02109117 35.1219512,2.28040889 L35.1219512,16.5853659" id="Stroke-3"></path>
                                  <path d="M38.3476085,33.1707317 L1.65239148,33.1707317 C0.739610262,33.1707317 0,32.4236961 0,31.5017509 L0,18.2543467 C0,17.3324015 0.739610262,16.5853659 1.65239148,16.5853659 L38.3476085,16.5853659 C39.2603897,16.5853659 40,17.3324015 40,18.2543467 L40,31.5017509 C40,32.4236961 39.2603897,33.1707317 38.3476085,33.1707317 Z" id="Stroke-5"></path>
                                  <line x1="10.2439024" y1="5.6097561" x2="29.2682927" y2="5.6097561" id="Stroke-7"></line>
                                  <line x1="10.2439024" y1="10.9756098" x2="29.2682927" y2="10.9756098" id="Stroke-9"></line>
                                  <line x1="10.4878049" y1="29.2682927" x2="10.4878049" y2="21.4634146" id="Stroke-11"></line>
                                  <polyline id="Stroke-13" points="24.8780488 29.2682927 24.8780488 21.4634146 28.7804878 21.4634146"></polyline>
                                  <path d="M10.7317073,21.4634146 L13.385397,21.4634146 C14.3441607,21.4634146 15.1219512,22.2282453 15.1219512,23.1709435 C15.1219512,24.1140652 14.3441607,24.8780488 13.385397,24.8780488 L10.7317073,24.8780488" id="Stroke-15"></path>
                                  <path d="M18.612952,29.2682927 L17.0731707,29.2682927 L17.0731707,21.4634146 L18.612952,21.4634146 C20.7263935,21.4634146 22.4390244,23.2106546 22.4390244,25.3658537 C22.4390244,27.5210527 20.7263935,29.2682927 18.612952,29.2682927 Z" id="Stroke-17"></path>
                                  <line x1="28.7804878" y1="25.1219512" x2="24.8780488" y2="25.1219512" id="Stroke-19"></line>
                                </g>
                              </g>
                            </g>
                          </g>
                        </g>
                      </svg>
                      <span>${r.data.title}</span>
                    </p>
                    <span data-href="${r.data.introduceBookUrlDesc}" data-title="${r.data.title}" class="z-button-fill-middle font-500">
                    <jds-icon name="download"></jds-icon>&nbsp;<span>${window.pageInfo.strings.product.download}</span></span>
                  </dd>
                `;
              this.selectors.manual.prepend(d_html);
              if (document.querySelector(".accordion--manual") && document.querySelectorAll(".accordion--manual dl dd").length > 0) {
                document.querySelector(".accordion--manual").classList.remove("hidden")
                const previousElementSibling = document.querySelector(".accordion--manual").previousElementSibling
                if (previousElementSibling) {
                  previousElementSibling.classList.remove("!mb-0")
                }
              }

              // 给 download 按钮，注册埋码事件
              const _this = this
              this.selectors.manual.find('.z-button-fill-middle').click(function () {
                gaProductDetailDataLayer({
                  "product_spu_name": _this.dataset.productTitle, // 识别页面产品spu标题名称text
                  "module": "Parameter", // 固定名称Parameter
                  "content": _this.productSpecsTitle, // 识别参数配置标题文本text
                  "position": _this.selectors.manual.data("section-title"), // 一级展开分类文本text
                  "button_name": $(this)?.data("title"), // 产品说明书名称
                  "type": "PDF Download", // 折叠fold，展开open / 下载-PDF Download
                })
                window.open($(this).data("href"), '_blank')
              })
            }
          })
      }
    }
  })
}

// 加电包
if (!customElements.get("what-is-in-the-box")) {
  customElements.define("what-is-in-the-box", class ProductFaq extends HTMLElement {
    constructor() {
      super()

      this.currentVariantId = this.dataset.currentVariantId

      // PC端最多显示4个，下标为3
      this.INIT_COLUMN_INDEX = 3
      this.tableContainer = this.querySelector(".table-container")
      this.leftArrow = this.querySelector(".table-left-arrow")
      this.rightArrow = this.querySelector(".table-right-arrow")
      this.currentIndex = this.INIT_COLUMN_INDEX

      const skuJsonString = this.querySelector('#variant-what-in-box-4-0')?.innerText || '[]'
      const spuJsonString = this.querySelector('#product-what-in-box-4-0')?.innerText || '[]'
      this.skuData = JSON.parse(skuJsonString)
      this.spuData = JSON.parse(spuJsonString)

      // 扁平化数据，得到加电包配置的所有数据列
      this.allData = this.spuData.map(({ skuId, list }) => list.map(({ img, name }) => {
        const [title, quantity] = name.split('*')
        return {
          skuId,
          img,
          name: title?.trim(),
          quantity: quantity?.trim()
        }
      })).flat()

      // 总变体数量
      this.totalSkuLength = this.skuData.length

      this.init()
    }
    init() {
      const whatsBox = document.querySelector(".accordion--whats-in-box")
      const isOnly = this.hasAttribute("only-default-variant")
      // 只有配置了数据才初始化
      if (this.allData.length > 0) {
        whatsBox && !isOnly && whatsBox.classList.remove("hidden")

        this.initPC()
        this.initMobile()

        // 监听变体切换
        document.addEventListener('variantChangeEvent', e => {
          const currentVariant = e.detail.variant
          if (currentVariant) {
            this.variantAutoScroll(currentVariant.id)

            if (this.mobileSkuBox) {
              // 更新 sku 图片
              const curTarget = this.skuData.find(item => item.skuId == currentVariant.id)
              curTarget && (this.mobileSkuBox.querySelector('.sku-img').src = curTarget.img)

              // 更新 配件显示
              this.mobileSkuBox.querySelectorAll('.sku-wrap[data-sku-id]').forEach(t => t.style.display = 'none')
              this.mobileSkuBox.querySelector(`.sku-wrap[data-sku-id="${currentVariant.id}"]`).style.display = 'flex'

              // 更新 select 显示
              this.mobileSkuBox.querySelector('select').value = currentVariant.id
            }
          }
        })
      } else { // 无数据 - 整个whats in box不显示
        whatsBox && !isOnly && whatsBox.classList.add("hidden")
      }
    }
    // Mobile 端切换
    initMobile() {
      this.mobileSkuBox = this.querySelector('.sku-box-wrap')
      this.mobileSkuBox.querySelector('select').addEventListener('change', (e) => {
        const selectedIndex = e.target.selectedIndex || 0
        const skuId = e.target.options[selectedIndex].value

        // 更新 sku 图片
        const curTarget = this.skuData.find(item => item.skuId == skuId)
        curTarget && (this.mobileSkuBox.querySelector('.sku-img').src = curTarget.img)

        // 更新 配件显示
        this.mobileSkuBox.querySelectorAll('.sku-wrap[data-sku-id]').forEach(t => t.style.display = 'none')
        this.mobileSkuBox.querySelector(`.sku-wrap[data-sku-id="${skuId}"]`).style.display = 'flex'
      })
    }
    // PC 端
    initPC() {
      const theadData = [null, ...this.skuData]

      // 数据分组
      const groupedData = this.allData.reduce((arr, item) => {
        // 如果分组对象中不存在该 name，则创建一个新数组
        if (!arr[item.name]) {
          arr[item.name] = []
        }
        // 将对象添加到对应 name 的数组中
        arr[item.name].push(item)
        return arr
      }, {})

      // 数组去重
      const uniqueData = [...new Map(this.allData.map(item => [item.name, item])).values()]

      const tbodyData = uniqueData.map(({ img, name, }) => {
        const rowSku = groupedData[name]
        const length = Math.max(this.totalSkuLength - rowSku.length, 0)
        const data = rowSku.concat(Array(length).fill(null))
        return { img, name, data }
      })
      this.renderTable(theadData, tbodyData)
    }
    renderTable(theadData, tbodyData) {
      // 创建表格
      let tableHTML = "<table><thead><tr>"

      // 获取并添加表头
      theadData.forEach((item, index) => {
        tableHTML += index === 0 ? `<th></th>` : `
            <th data-sku-id="${item?.skuId}">
              <div>
                <img src="${item?.img}" alt="" loading="lazy">
                <h4 title="${item?.name}">${item?.name}</h4>
              </div>
            </th>
          `
      })
      tableHTML += "</tr></thead><tbody>"

      // 添加数据行
      tbodyData.forEach(item => {
        tableHTML += '<tr>'
        theadData.forEach((header, index) => {
          const quantity = item.data.find(row => header?.skuId == row?.skuId)?.quantity
          tableHTML += index === 0 ? `
              <td>
                <div>
                  <img src="${item?.img}" alt="" loading="lazy">
                  <span title="${item?.name}">${item?.name}</span>
                </div>
              </td>
            ` : `<td data-sku-id="${header?.skuId}"><div>${quantity ? `X${quantity}` : '-'}</div></td>`
        })
        tableHTML += '</tr>'
      })

      tableHTML += "</tbody></table>"
      this.tableContainer.innerHTML = tableHTML
      this.initTable()
    }
    initTable() {
      this.table = this.tableContainer.querySelector('table')

      this.tableCell = []
      for (let row of this.table.rows) {
        for (let cell of row.cells) {
          if (row.rowIndex === 0 && cell.cellIndex !== 0) {
            this.tableCell.push(cell.getBoundingClientRect().width)
          }
        }
      }

      this.variantAutoScroll(this.currentVariantId)

      // 变体数量超过 4 个，才显示左右箭头
      if (this.totalSkuLength > 4) {
        this.initTableArrowEvent()
      }
    }
    // 高亮当前变体列
    initTableHighlight(variantId) {
      if (!variantId) return
      // 移除全部
      this.table.querySelectorAll('[data-sku-id]').forEach(t => t.classList.remove('active-column'))
      this.table.querySelectorAll(`[data-sku-id="${variantId}"]`).forEach(t => t.classList.add('active-column'))
    }
    // 左右箭头
    initTableArrowEvent() {
      this.leftArrow.parentElement.style.display = 'flex'

      // 左箭头
      this.leftArrow.onclick = (e) => {
        this.currentIndex = Math.max(this.INIT_COLUMN_INDEX, this.currentIndex - 1)
        const scrollXWidth = Math.max(0, this.tableContainer.scrollLeft - this.tableCell[this.currentIndex])
        this.tableContainer.scrollTo({
          left: scrollXWidth,
          behavior: "smooth"
        })
        this.rightArrow.removeAttribute("disabled")
        if (this.currentIndex === this.INIT_COLUMN_INDEX) {
          this.leftArrow.setAttribute("disabled", "disabled")
        }
      }

      // 右箭头
      this.rightArrow.onclick = (e) => {
        this.currentIndex = Math.min(this.totalSkuLength - 1, this.currentIndex + 1)
        const scrollXWidth = this.tableCell[this.currentIndex] * (this.currentIndex - this.INIT_COLUMN_INDEX)
        this.tableContainer.scrollTo({
          left: scrollXWidth,
          behavior: "smooth"
        })
        this.leftArrow.removeAttribute("disabled")
        if (this.currentIndex === this.totalSkuLength - 1) {
          this.rightArrow.setAttribute("disabled", "disabled")
        }
      }
    }

    // 切换变体，自动滚动到对应位置并高亮
    variantAutoScroll(variantId) {
      // 高亮当前sku
      this.initTableHighlight(variantId)

      // 变体数量超过 4 个，才自动滚动
      if (this.totalSkuLength > 4) {
        // 当前变体索引
        const index = this.skuData.findIndex(item => item.skuId == variantId)

        // 索引间隔
        const indexGap = Math.max(0, index - this.INIT_COLUMN_INDEX)

        // 需要滚动的距离（已考虑不等宽的情况）
        const scrollXWidth = indexGap === 0 ? 0 : this.tableCell.slice(4, index + 1).reduce((prev, next) => prev += next, 0)

        this.tableContainer.scrollTo({
          left: scrollXWidth,
          behavior: "smooth"
        })

        // 更新按钮状态
        if (scrollXWidth > 0) {
          this.leftArrow.removeAttribute("disabled")
          if (index === this.totalSkuLength - 1) {
            this.rightArrow.setAttribute("disabled", "disabled")
          } else {
            this.rightArrow.removeAttribute("disabled")
          }
        } else {
          this.leftArrow.setAttribute("disabled", "disabled")
          this.rightArrow.removeAttribute("disabled")
        }
      }
    }
  })
}
